<template>
  <v-menu
    ref="menu"
    offset-y
    nudge-bottom="8px"
    nudge-right="6px"
  >
    <template v-slot:activator="{ on, attrs }">
      <button
        v-bind="attrs"
        v-on="on"
        class="px-1"
      >
        <v-icon>calendar_view_month</v-icon>
        <v-icon class="ml-n2">
          arrow_drop_down
        </v-icon>
      </button>
    </template>
    <v-list dense class="pa-0">
      <v-list-item class="tableMenuListItem">
        <GridSizeSelector @click="insertTable" />
      </v-list-item>
      <v-divider />
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().addRowBefore().run()"
        >
          {{ $t('components.editor.tableMenuActions.addRowBefore') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().addRowAfter().run()"
        >
          {{ $t('components.editor.tableMenuActions.addRowAfter') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().addColumnBefore().run()"
        >
          {{ $t('components.editor.tableMenuActions.addColumnBefore') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().addColumnAfter().run()"
        >
          {{ $t('components.editor.tableMenuActions.addColumnAfter') }}
        </button>
      </v-list-item>
      <v-divider />
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().deleteRow().run()"
        >
          {{ $t('components.editor.tableMenuActions.deleteRow') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().deleteColumn().run()"
        >
          {{ $t('components.editor.tableMenuActions.deleteColumn') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().deleteTable().run()"
        >
          {{ $t('components.editor.tableMenuActions.deleteTable') }}
        </button>
      </v-list-item>
      <v-divider />
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().mergeCells().run()"
        >
          {{ $t('components.editor.tableMenuActions.mergeCells') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().splitCell().run()"
        >
          {{ $t('components.editor.tableMenuActions.splitCell') }}
        </button>
      </v-list-item>
      <v-divider />
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().toggleHeaderRow().run()"
        >
          {{ $t('components.editor.tableMenuActions.headerRow') }}
        </button>
      </v-list-item>
      <v-list-item class="tableMenuListItem">
        <button
          class="tableMenuItemBtn"
          @click="editor.chain().focus().toggleHeaderColumn().run()"
        >
          {{ $t('components.editor.tableMenuActions.headerColumn') }}
        </button>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import GridSizeSelector from './GridSizeSelector';

export default {
  name: 'EditorTableMenu',
  components: {
    GridSizeSelector,
  },
  props: {
    editor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    insertTable(size) {
      this.$refs.menu.save();
      this.$emit('insertTable', size);
    },
  },
};
</script>

<style scoped>
.tableMenuListItem {
  padding: 0;
  min-height: 30px;
}

.tableMenuListItem:hover {
  background-color: lightgrey;
}

.tableMenuItemBtn {
  padding: 0px 8px;
  font-size: 12px;
}
</style>
